var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-l-5 m-b-10" }, [
    _c("div", { staticClass: "m-b-2 m-t-10" }, [
      _c("strong", [_vm._v(_vm._s(_vm.columnDisplayName))])
    ]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "table_beauty condensed-alternate routing-plan-args" },
      [
        _c("thead", [
          _c("tr", { staticClass: "bg-transparent" }, [
            _c("th", [_vm._v(_vm._s(_vm.$t("RTB_REROUTE_NAME")))]),
            _vm._v(" "),
            _vm.columnName.toLowerCase() === "ineligibletargets"
              ? _c("th", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("RTB_REROUTE_REASON")) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("th", { staticClass: "text-right rtb-reroute-args__bids" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("RTB_REROUTE_BID")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right rtb-reroute-args__bids" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("RTB_REROUTE_MIN_TARGET_BID")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "text-right rtb-reroute-args__bids" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("RTB_REROUTE_TARGET_BID")) +
                  "\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.parsedRerouteEligibilityDetail, function(target, index) {
            return _c(
              "tr",
              {
                key: index,
                staticClass: "bg-transparent",
                class: [
                  target.reasons && target.reasons.length > 1
                    ? "vertical-top"
                    : ""
                ]
              },
              [
                _c("td", [
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.hover",
                          value: _vm.$t("RTB_REROUTE_VIEW_TARGET"),
                          expression:
                            "\n              $t('RTB_REROUTE_VIEW_TARGET')\n            ",
                          modifiers: { top: true, hover: true }
                        }
                      ],
                      staticClass: "table-ellipsis__name linked-name",
                      attrs: { href: target.url, target: "_blank" }
                    },
                    [_vm._v(_vm._s(target.name))]
                  )
                ]),
                _vm._v(" "),
                _vm.columnName.toLowerCase() === "ineligibletargets"
                  ? _c(
                      "td",
                      _vm._l(target.reasons, function(reason, i) {
                        return _c("div", { key: i }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                reason
                                  ? reason
                                  : _vm.$t("RTB_REROUTE_REASON_TEXT")
                              ) +
                              "\n          "
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v("\n          $" + _vm._s(target.bid) + "\n        ")
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          $" +
                      _vm._s(target.minimumMargin) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          $" + _vm._s(target.targetBid) + "\n        "
                  )
                ])
              ]
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }